<template>
  <div class="mt-1">
    <button :style="btnStyle(1)" @click="clicked(1)">
      <i class="fas fa-star"></i>
    </button>
    <button :style="btnStyle(2)" @click="clicked(2)">
      <i class="fas fa-star"></i>
    </button>
    <button :style="btnStyle(3)" @click="clicked(3)">
      <i class="fas fa-star"></i>
    </button>
    <button :style="btnStyle(4)" @click="clicked(4)">
      <i class="fas fa-star"></i>
    </button>
    <button :style="btnStyle(5)" @click="clicked(5)">
      <i class="fas fa-star"></i>
    </button>
  </div>
</template>

<script>
export default {
  props: ['value'],
  methods: {
    clicked(value) {
      this.$emit('input', value)
    },
    btnStyle(value) {
      return {
        border: '0px',
        'background-color': 'white',
        'padding-left': '0px',
        'padding-right': '0px',
        'font-size': 'x-large',
        color: value <= this.value ? 'tomato' : 'gray'
      }
    }
  },
  computed: {
  }
}
</script>

<style scoped>
</style>
